"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = '.icon__btn_elem{border:0;background:rgba(0,0,0,0);padding:1px;line-height:0;color:var(--black_80);cursor:pointer}.icon__elem.icon__xxs{font-size:var(--i-xxs)}.icon__elem.icon__xs{font-size:var(--i-xs)}.icon__elem.icon__sm{font-size:var(--i-sm)}.icon__elem.icon__md{font-size:var(--i-md)}.icon__elem.icon__lg{font-size:var(--i-lg)}.icon__elem.icon__xl{font-size:var(--i-xl)}.icon__elem.icon__xxl{font-size:var(--i-xxl)}.icon__elem.icon__xxxl{font-size:var(--i-xxxl)}';